import { render, staticRenderFns } from "./SupplierTypeform.vue?vue&type=template&id=1fd643ad"
import script from "./SupplierTypeform.vue?vue&type=script&lang=js"
export * from "./SupplierTypeform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports